module.exports = __webpack_public_path__ + "img/a1.6c480aeb.jpg";